import React, { useEffect } from 'react';
import { routes } from './routes';

import store from './store/grtAi';

function App() {
    useEffect(() => {
        store.getTenantId();
        store.getTenantConfig();
    }, []);
    return <div className="App">{routes}</div>;
}

export default App;
